var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gwd-table-row"},[_c('span',{staticClass:"flex"},[_vm._v(_vm._s(_vm.cost.name))]),_c('span',{staticClass:"flex"},[_vm._v(_vm._s(_vm.cost.amount)+" "+_vm._s(_vm.cost.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }